import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type MaturityEventDto, type MaturityEventUpdateDto, updateMaturityEvent } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateMaturityEvent = (): UseMutationResult<MaturityEventDto, AxiosError, MaturityEventUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (event) => updateMaturityEvent({ path: { clientId: client!.id }, body: event }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.balanceSheet(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
    });
};
